import { render, staticRenderFns } from "./bindlist.vue?vue&type=template&id=ec3447ba&"
import script from "./bindlist.vue?vue&type=script&lang=js&"
export * from "./bindlist.vue?vue&type=script&lang=js&"
import style0 from "./bindlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports